// extracted by mini-css-extract-plugin
export default {"boxcontainer":"PartnerContent5_boxcontainer__LAEdS"};